import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { setTrackLink } from '@vfit/shared/data-access';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const taggingMobile = getTagging('address confirmation', 'mobile', client);
  const { trackView } = useTracking({
    event: ['checkout_step5'],
    event_label: 'address confirmation',
    opts: taggingMobile?.opts,
    cartProduct: taggingMobile?.trackingProduct,
    pageProduct: taggingMobile?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'address confirmation');
  setTrackView(trackView);

  return null;
};

const TaggingYouAddressCard = withAnimationDelay()(TaggingComponent);

export default TaggingYouAddressCard;
